import { canv } from '@/canv/global.js'

export class shapeOctagon {

    constructor() {

    }


    fitText(textPart, x, y, width, height, verticalPadding, horizontalPadding) {

        var allowedWidth = width * 2/3 - 2 * horizontalPadding;
        var allowedHeight = height * 2/3 - 2 * verticalPadding;


        textPart.hardWidth = allowedWidth;
        textPart.fitShape();
        textPart.updateDims();

        textPart.startX = x + width / 2 - textPart.width / 2;
        textPart.startY = y + textPart.lines[0].textHeight + height / 2 - textPart.height / 2;

        textPart.updateDims();

        return {
            "allowedWidth": allowedWidth,
            "allowedHeight": allowedHeight
        };
    }

    draw(x, y, width, height) {
        canv.ctx.beginPath();
        canv.ctx.moveTo(x, y + height * 3/10);
        canv.ctx.lineTo(x + width * 3/10, y);
        canv.ctx.lineTo(x + width * 7/10, y);
        canv.ctx.lineTo(x + width, y + height * 3/10);
        canv.ctx.lineTo(x + width, y + height * 7/10);
        canv.ctx.lineTo(x + width * 7/10, y + height);
        canv.ctx.lineTo(x + width * 3/10, y + height);
        canv.ctx.lineTo(x, y + height * 7/10);
        canv.ctx.lineTo(x, y + height * 3/10);
    }

    getAvatar(color) {
        return `
        <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M78.828 22.828L57.168 1.172C56.418 0.4218 55.4048 0.00024 54.344 0H25.656C24.5952 0.00024 23.578 0.4218 22.828 1.172L1.172 22.828C0.4218 23.578 0.00024 24.5952 0 25.656V54.344C0.00024 55.4048 0.4218 56.422 1.172 57.172L22.828 78.828C23.578 79.5784 24.5952 79.9996 25.656 80H54.344C55.4048 79.9996 56.422 79.5784 57.172 78.828L78.828 57.172C79.5784 56.422 79.9996 55.4048 80 54.344V25.656C79.9996 24.5952 79.5784 23.578 78.828 22.828Z"
        fill="` + color + `"/>
        </svg>
        `;
    }

    getView(reason = "shapeToolSubMenu",  bgColor = "white", borderColor = "black") {
        let width = 25;
        let height = 25;
        let fill = "white";
        let stroke = "black";

        if (reason === "shapeToolSubMenu") {
            width = 25;
            height = 25;
        } else if (reason === "shapeLibrary") {
            width = 30;
            height = 30;
        } else if (reason === "voteResult") {
            width = 170;
            height = 170;
            fill = bgColor;
            stroke = borderColor;
        }

        return `
            <svg width="` + width + `" height="` + height + `" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M17.5115 0.719836L17.5114 0.719756C17.3704 0.578736 17.1808 0.500075 16.9825 0.5L17.5115 0.719836ZM17.5115 0.719836L24.2802 7.48734L24.2803 7.48741M17.5115 0.719836L24.2803 7.48741M24.2803 7.48741C24.4209 7.62787 24.4999 7.81849 24.5 8.0175M24.2803 7.48741L24.5 8.0175M24.2802 17.5127L24.2803 17.5126C24.4209 17.3721 24.4999 17.1815 24.5 16.9825L24.2802 17.5127ZM24.2802 17.5127L17.5127 24.2802L17.5126 24.2803M24.2802 17.5127L17.5126 24.2803M17.5126 24.2803C17.3721 24.4209 17.1815 24.4999 16.9825 24.5M17.5126 24.2803L16.9825 24.5M7.4873 24.2802L7.48741 24.2803C7.62787 24.4209 7.81849 24.4999 8.0175 24.5L7.4873 24.2802ZM7.4873 24.2802L0.719803 17.5127L0.719756 17.5126M7.4873 24.2802L0.719756 17.5126M0.719756 17.5126C0.579112 17.372 0.500075 17.1814 0.5 16.9825M0.719756 17.5126L0.5 16.9825M0.719803 7.4873L0.719747 7.48736C0.579118 7.62794 0.500075 7.81863 0.5 8.0175L0.719803 7.4873ZM0.719803 7.4873L7.4873 0.719803L7.48736 0.719747M0.719803 7.4873L7.48736 0.719747M7.48736 0.719747C7.62794 0.579118 7.81863 0.500075 8.0175 0.5M7.48736 0.719747L8.0175 0.5M24.5 8.0175C24.5 8.01756 24.5 8.01763 24.5 8.01769M24.5 8.0175V8.01769M24.5 8.01769V16.9823V8.01769ZM16.9825 24.5C16.9824 24.5 16.9824 24.5 16.9823 24.5M16.9825 24.5H16.9823M16.9823 24.5H8.01769H16.9823ZM0.5 16.9825C0.5 16.9825 0.5 16.9824 0.5 16.9824M0.5 16.9825V16.9824M0.5 16.9824V8.01761V16.9824ZM8.0175 0.5C8.01754 0.5 8.01758 0.5 8.01761 0.5M8.0175 0.5H8.01761M8.01761 0.5H16.9824H8.01761Z" fill="` + fill + `" stroke="` + stroke + `"/>
            </svg>
        `;
    }

}
